// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 14 14%27%3E%3Cpath fill=%27%23333333%27 d=%27M14 1.4L12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4l5.6 5.6 1.4-1.4L8.4 7z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#buorg {
  height: 65px;
  background-color: rgba(245, 245, 245, 0.9);
  box-shadow: 0px 3px 6px rgba(0,0,0,0.10196);
  border: none;
}

body .buorg-pad {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 0;
}

body .buorg-pad .buorg-icon {
  display: none;
}

body .buorg-mainmsg,
body .buorg-moremsg {
  display: flex;
  flex-basis: 40%;
  flex-grow: 1;
  color: #333333;
  white-space: nowrap;
  letter-spacing: 0px;
  font: normal normal 14px/65px SansOri;
}

body .buorg-mainmsg {
  justify-content: flex-end;
  font-weight: bold;
  padding-right: 7px;
}

body .buorg-moremsg {
  justify-content: flex-start;
}

body .buorg-buttons {
  flex-basis: 254px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

body #buorgul {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 128px;
  height: 35px;
  margin: 0;
  background: #68bb93 0% 0% no-repeat padding-box;
  border-radius: 18px;
  box-sizing: border-box;
  box-shadow: none;
  font: normal normal bold 14px/35px SansOri;
  letter-spacing: 0px;
}

body #buorgig {
  border: none;
  height: 23px;
  width: 23px;
  padding: 0;
  margin: 0;
  box-shadow: none;
  box-sizing: border-box;
  margin-right: 40px;
  overflow: hidden;
  color: transparent;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat center center;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

body #buorgig > svg {
  padding: 0;
  height: 100%;
  width: 100%;
}
body .buorg-test {
  display: none;
}

@media (max-width: 900px) {
  body .buorg-pad {
    margin: 15px 45px;
  }
}
@media (max-width: 900px) {
  body #buorg {
    height: -moz-fit-content;
    height: fit-content;
  }

  body .buorg-pad {
    max-height: 131px;
    flex-direction: column;
    flex-wrap: wrap;
  }
  body .buorg div {
    padding: 0;
  }

  body .buorg-mainmsg,
  body .buorg-moremsg {
    padding: 1px 2px;
    white-space: normal;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0;
  }

  body #buorgig {
    position: fixed;
    margin: 0;
    top: 13px;
    right: 10px;
  }

  body .buorg-buttons {
    margin-top: 15px;
    flex-basis: 50%;
  }
}

/* IE support  - Flex box doesn't work properly*/
@media screen and (min-width: 0\\0) and (min-resolution: +72dpi) {
  body .buorg-pad {
    display: block;
    position: relative;
    min-width: 1100px;
    width: 100%;
    height: 100%;
    text-align: right;
    white-space: nowrap;
  }

  body .buorg-mainmsg,
  body .buorg-moremsg {
    display: inline-block;
    box-sizing: border-box;
    padding: 0;
    width: 40.7%;
  }

  body .buorg-mainmsg {
    text-align: right;
  }

  body .buorg-moremsg {
    text-align: left;
  }

  body .buorg-buttons {
    position: relative;
    display: inline-block;
    width: 18.59%;
    max-width: 254px;
    min-width: 150px;
    height: 100%;
    text-align: right;
  }

  body #buorgul {
    position: absolute;
    display: inline-block;
    margin: 0;
    width: 128px;
    height: 35px;
    padding-top: 2px;
    text-align: center;
  }

  body #buorgig {
    display: inline-block;
    height: 23px;
    transform: translateY(30%);
  }
}

@media screen and (min-width: 0\\0) and (min-resolution: +72dpi) and (max-width: 1240px) {
  body .buorg-mainmsg,
  body .buorg-moremsg {
    transform: translateX(-12%);
  }
}

@media screen and (min-width: 0\\0) and (min-resolution: +72dpi) and (max-width: 900px) {
  body .buorg-pad {
    display: relative;
    width: 100%;
    min-width: 444px;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  body .buorg-mainmsg,
  body .buorg-moremsg {
    display: block;
    width: 100%;
    text-align: center;
    padding-left: 45px;
    padding-right: 45px;
    transform: translateX(0);
  }

  body .buorg-mainmsg {
    margin-top: 16px;
  }
  body .buorg-buttons {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    margin: 0;
    height: 131px;
    width: 100%;
    max-width: 100%;
  }

  body #buorgul {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
  }

  body #buorgig {
    position: absolute;
    top: 0;
    transform: translateY(-10px);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/outdated-browser-info/dist/cjs/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0CAA0C;EAC1C,2CAAiC;EACjC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,+CAA+C;EAC/C,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;2BACyB;EACzB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,OAAO;IACP,SAAS;IACT,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,4BAA4B;EAC9B;AACF","sourcesContent":["#buorg {\n  height: 65px;\n  background-color: rgba(245, 245, 245, 0.9);\n  box-shadow: 0px 3px 6px #0000001a;\n  border: none;\n}\n\nbody .buorg-pad {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  padding: 0;\n}\n\nbody .buorg-pad .buorg-icon {\n  display: none;\n}\n\nbody .buorg-mainmsg,\nbody .buorg-moremsg {\n  display: flex;\n  flex-basis: 40%;\n  flex-grow: 1;\n  color: #333333;\n  white-space: nowrap;\n  letter-spacing: 0px;\n  font: normal normal 14px/65px SansOri;\n}\n\nbody .buorg-mainmsg {\n  justify-content: flex-end;\n  font-weight: bold;\n  padding-right: 7px;\n}\n\nbody .buorg-moremsg {\n  justify-content: flex-start;\n}\n\nbody .buorg-buttons {\n  flex-basis: 254px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\nbody #buorgul {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 128px;\n  height: 35px;\n  margin: 0;\n  background: #68bb93 0% 0% no-repeat padding-box;\n  border-radius: 18px;\n  box-sizing: border-box;\n  box-shadow: none;\n  font: normal normal bold 14px/35px SansOri;\n  letter-spacing: 0px;\n}\n\nbody #buorgig {\n  border: none;\n  height: 23px;\n  width: 23px;\n  padding: 0;\n  margin: 0;\n  box-shadow: none;\n  box-sizing: border-box;\n  margin-right: 40px;\n  overflow: hidden;\n  color: transparent;\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Cpath fill='%23333333' d='M14 1.4L12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4l5.6 5.6 1.4-1.4L8.4 7z'/%3E%3C/svg%3E\")\n    no-repeat center center;\n  user-select: none;\n}\n\nbody #buorgig > svg {\n  padding: 0;\n  height: 100%;\n  width: 100%;\n}\nbody .buorg-test {\n  display: none;\n}\n\n@media (max-width: 900px) {\n  body .buorg-pad {\n    margin: 15px 45px;\n  }\n}\n@media (max-width: 900px) {\n  body #buorg {\n    height: fit-content;\n  }\n\n  body .buorg-pad {\n    max-height: 131px;\n    flex-direction: column;\n    flex-wrap: wrap;\n  }\n  body .buorg div {\n    padding: 0;\n  }\n\n  body .buorg-mainmsg,\n  body .buorg-moremsg {\n    padding: 1px 2px;\n    white-space: normal;\n    font-size: 12px;\n    line-height: 17px;\n    letter-spacing: 0;\n  }\n\n  body #buorgig {\n    position: fixed;\n    margin: 0;\n    top: 13px;\n    right: 10px;\n  }\n\n  body .buorg-buttons {\n    margin-top: 15px;\n    flex-basis: 50%;\n  }\n}\n\n/* IE support  - Flex box doesn't work properly*/\n@media screen and (min-width: 0\\0) and (min-resolution: +72dpi) {\n  body .buorg-pad {\n    display: block;\n    position: relative;\n    min-width: 1100px;\n    width: 100%;\n    height: 100%;\n    text-align: right;\n    white-space: nowrap;\n  }\n\n  body .buorg-mainmsg,\n  body .buorg-moremsg {\n    display: inline-block;\n    box-sizing: border-box;\n    padding: 0;\n    width: 40.7%;\n  }\n\n  body .buorg-mainmsg {\n    text-align: right;\n  }\n\n  body .buorg-moremsg {\n    text-align: left;\n  }\n\n  body .buorg-buttons {\n    position: relative;\n    display: inline-block;\n    width: 18.59%;\n    max-width: 254px;\n    min-width: 150px;\n    height: 100%;\n    text-align: right;\n  }\n\n  body #buorgul {\n    position: absolute;\n    display: inline-block;\n    margin: 0;\n    width: 128px;\n    height: 35px;\n    padding-top: 2px;\n    text-align: center;\n  }\n\n  body #buorgig {\n    display: inline-block;\n    height: 23px;\n    transform: translateY(30%);\n  }\n}\n\n@media screen and (min-width: 0\\0) and (min-resolution: +72dpi) and (max-width: 1240px) {\n  body .buorg-mainmsg,\n  body .buorg-moremsg {\n    transform: translateX(-12%);\n  }\n}\n\n@media screen and (min-width: 0\\0) and (min-resolution: +72dpi) and (max-width: 900px) {\n  body .buorg-pad {\n    display: relative;\n    width: 100%;\n    min-width: 444px;\n    top: 0;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    text-align: center;\n  }\n\n  body .buorg-mainmsg,\n  body .buorg-moremsg {\n    display: block;\n    width: 100%;\n    text-align: center;\n    padding-left: 45px;\n    padding-right: 45px;\n    transform: translateX(0);\n  }\n\n  body .buorg-mainmsg {\n    margin-top: 16px;\n  }\n  body .buorg-buttons {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    margin: 0;\n    height: 131px;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  body #buorgul {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  body #buorgig {\n    position: absolute;\n    top: 0;\n    transform: translateY(-10px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
